import { CURRENT_PAYMENT_APP_VERSION } from '../../config/constants';
import { useFlag } from '../../services/launchDarkly';
import type { SystemErrorCodes } from '../../stores/app/types';

import { ExternalPaymentsV2 as V2Component } from './v2/ExternalPayments';
import { ExternalPaymentsV4 as V4Component } from './v4/ExternalPayments';
import { ExternalPaymentsV5 as V5Component } from './v5/ExternalPayments';

export function ExternalPayments(props: {
  paymentMethod?: string;
  errorCode?: SystemErrorCodes;
  errorDetails?: string;
  presetIframeParams?: string;
  storeType: 'store' | 'mini-store' | 'subscription';
}) {
  const version = useFlag<number>('payments_app_version', CURRENT_PAYMENT_APP_VERSION);

  switch (version) {
    case 5:
      return <V5Component storeType={props.storeType} />;
    case 4:
      return <V4Component storeType={props.storeType} />;
    default:
      return <V2Component {...props} />;
  }
}
